var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.WarmReminder"),
        width: "520px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "confirm-text",
          staticStyle: { margin: "20px 0 15px 60px" }
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("CargoMsg.Cargo_ConfirmReturnResubmit")) + " "
          )
        ]
      ),
      _c(
        "el-form",
        {
          staticStyle: { margin: "0 0 20px 60px" },
          attrs: { "label-position": "left", "label-width": "100px" }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("CargoMsg.Cargo_ReturnModuleSelection") }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "full-width",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("common.placeholder.select") },
                  model: {
                    value: _vm.returnType,
                    callback: function($$v) {
                      _vm.returnType = $$v
                    },
                    expression: "returnType"
                  }
                },
                _vm._l(_vm.moduleOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_ReturnReason") } },
            [
              _c("el-input", {
                staticClass: "full-width",
                staticStyle: { width: "300px" },
                attrs: { type: "textarea", rows: 3 },
                model: {
                  value: _vm.returnRemark,
                  callback: function($$v) {
                    _vm.returnRemark = $$v
                  },
                  expression: "returnRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "ok" },
              on: { click: _vm.btnConfirm }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }